import React from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import axiosInstance from '../../services/axiosInstance';

function LogoModal({ logoOptions, selectedLogo, onClose, onPrev, onNext, onSetLogo }) {
  const currentIndex = logoOptions.indexOf(selectedLogo);
  const totalLogos = logoOptions.length;

  const handleSetAsLogo = async () => {
    try {
      // Extract just the filename from the full path
      const filename = selectedLogo.split('/').pop();

      // Make an API call to save the selected logo for the logged-in user
      await axiosInstance.post('/logo-settings/', {
        logo_filename: selectedLogo.split('/').pop()
      });

      // Trigger a page-level event that Navigation can listen to
      window.dispatchEvent(new Event('logoUpdated'));
      alert('Settings updated successfully!');
      onClose();
    } catch (error) {
      console.error('Error setting logo:', error.name);
      alert('Please try again.');
    }
  };

  const handleModalClick = (e) => {
    // If the click is on the modal background (not the image or buttons)
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="image-modal" onClick={handleModalClick}>
      <div className="logo-preview-container">
        {currentIndex > 0 && <FaChevronLeft className="nav-icon" onClick={(e) => { e.stopPropagation(); onPrev(); }} />}
        <img src={selectedLogo} alt="Selected Logo" />
        {currentIndex < totalLogos - 1 && <FaChevronRight className="nav-icon" onClick={(e) => { e.stopPropagation(); onNext(); }} />}
        <button className="set-logo-btn" onClick={handleSetAsLogo}>Set as Logo</button>
      </div>
      <FaTimes className="modal-close-btn" onClick={onClose} />
    </div>
  );
}

export default LogoModal;
